import MasterNav from '@patsnap-biz/master-nav';
import { SEARCH_NAV_CONFIG, INACTIVE_SEARCH_NAV_CONFIG } from '../components/search-left-nav/config';
import getSearchInit from '../apis/search_init_api/searchInit';
import _ from 'lodash';
import { Site } from '@patsnap-utils/biz';
import { CAS2_URI } from 'library-@/config/apiConfig';
import { proxyDefaultValue } from 'library-@/componentZPrefaceProxy/proxyDefaultValue';
import '@patsnap-ui/icon/assets/solid/NavSearch.svg';
import '@patsnap-ui/icon/assets/solid/IntegrateHistory.svg';
import '@patsnap-ui/icon/assets/solid/CoreProductsInsights.svg';
import '@patsnap-ui/icon/assets/solid/CoreProductsLandscape.svg';
import '@patsnap-ui/icon/assets/solid/ChartChunk.svg';
import '@patsnap-ui/icon/assets/solid/ContentFormatingGrid3.svg';
import '@patsnap-ui/icon/assets/solid/EmailAlerts.svg';
import '@patsnap-ui/icon/assets/solid/HistoryRecord.svg';
import '@patsnap-ui/icon/assets/solid/NavWorkspace.svg';
import '@patsnap-ui/icon/assets/solid/GroupedAssignee.svg';
import '@patsnap-ui/icon/assets/solid/Cas.svg';
import '@patsnap-ui/icon/assets/solid/polls.svg';
import '@patsnap-ui/icon/assets/solid/Telecom.svg';


const { get, forEach, map, remove, findIndex, find, clone } = _;
const navService = new MasterNav.NavService();
navService.partitions = [];

const CAS_SEARCH = [
    {
        key: 'cas_search',
        icon: 'SolidCas',
        label: 'searchMenus.cas_search',
        children: [
            {
                key: 'structure_search',
                label: 'searchMenus.structure',
                routeName: 'ChemicalStructure',
                fullPath: `${CAS2_URI}/#/search/structure`
            },
            {
                key: 'markush_search',
                label: 'searchMenus.markush',
                routeName: 'ChemicalMarkush',
                fullPath: `${CAS2_URI}/#/search/markush?type=markush&mode=drw`
            },
            {
                key: 'substances_search',
                label: 'searchMenus.substances',
                routeName: 'ChemicalText',
                fullPath: `${CAS2_URI}/#/search/text`
            },
        ],
    },
];

const TELECOM_SEARCH = [
    {
        key: 'telecom_search',
        icon: 'SolidTelecom',
        label: 'commonNav.telecom',
        children: [
            {
                key: 'tdoc_search',
                label: 'searchMenus.telecom_tdoc',
                pathKey: 'analytics',
                url: 'telecom'
            },
        ],
    },
];

const AI_LAB_LIST = [
  {
    key: 'aiLab',
    icon: '',
    label: '',
    pathKey: 'analytics',
    url: 'ai-lab',
  },
];

const SEARCH_LIST = [
    {
        key: 'search',
        icon: 'SolidNavSearch',
        label: 'commonNav.patent',
        children: []
    },
    {
        key: 'my_searches',
        icon: 'SolidIntegrateHistory',
        label: 'historyQuery.historyQueries',
        children: [
            { key: 'searchHistory', pathKey: 'home', url: 'history/#/analytics/1/1?from_site=analytics' },
            { key: 'savedSearches', label: 'commonNav.savedSearches', routeName: 'historyQuerySavedSearchesView', url: '/my/history#/history-query/saved/1' },
            {
                key: 'savedCASSearches',
                label: 'commonNav.savedCASSearches',
                fullPath: `${CAS2_URI}/#/saved-searches`,
            },
        ]
    },
];


const TOOL_LIST = [
    'sidebar_tools',
    {
        key: 'analyze',
        icon: 'SolidPolls',
        label: 'commonNav.analyze',
        children: [
            { key: 'insights', icon: 'SolidCoreProductsInsights', pathKey: 'insights', url: '' },
            { key: 'landscape', icon: 'SolidCoreProductsLandscape', pathKey: 'analytics', url: 'landscape#/home' },
            { key: 'charts', icon: 'SolidChartChunk', pathKey: 'dashboard', url: 'charts?from_site=analytics' },
            { key: 'dashboard', icon: 'SolidContentFormatingGrid3', pathKey: 'dashboard', url: 'dashboards?from_site=analytics' },
        ]
    },
    { key: 'workspace', icon: 'SolidNavWorkspace', pathKey: 'workspace', url: '' },
    { key: 'alert', icon: 'SolidEmailAlerts', pathKey: 'home', url: 'alert' },
    { key: 'history', icon: 'SolidHistoryRecord', pathKey: 'home', url: 'history/#/analytics/0/1?from_site=analytics' },
    { key: 'assigneegrouping', icon: 'SolidGroupedAssignee', pathKey: 'home', url: 'gname' },
];

export async function getSearchNavList({ isSpecialIp, siteRegion }) {
    let originSearchList = [];
    let savedQueryAuth;
    // 是否有专家检索权限
    let hasExpert;
    let legalCaseLabData;
    // 是否有cas权限
    let hasCas;
    // 是否有telecom权限
    let hasTelecom;
    let hasAILab;

    const { initData, searchTabs } = await getSearchInit();
    originSearchList = clone(searchTabs) || [];
    savedQueryAuth = get(initData, 'permissions.saveQuery', false);
    hasExpert = get(initData, 'permissions.combineSearch', false);
    legalCaseLabData = get(initData, 'permissions.legalCase', false);
    hasCas = get(initData, 'permissions.cas', false);
    hasTelecom = get(initData, 'permissions.telecom', false);
    hasAILab = get(initData, 'permissions.aiLab', false);

    // FIXME: Search已不存在zPREFACE
    const showLegalCase = ((siteRegion || proxyDefaultValue.siteRegion) === 'CN') && !(isSpecialIp || proxyDefaultValue.isSpecialIp);

    if (showLegalCase && legalCaseLabData) {
        const legalIndex = findIndex(originSearchList, {
            key: 'legalSearch'
        });
        if (legalIndex !== -1 && legalCaseLabData.staging === 'approved' && legalCaseLabData.used) {
            originSearchList.splice(legalIndex + 1, 0, {
                key: 'legalCase',
                labData: legalCaseLabData
            });
        }
    }

    const searchNavs = map(originSearchList,
        (item) => {
            const label = `snapBusiness.headerV2.searchTabs.${item.key}`;
            item = { ...SEARCH_NAV_CONFIG[item.key], ...item, label };
            return item;
        });

    const inactiveSearchNavs = [];
    INACTIVE_SEARCH_NAV_CONFIG.forEach((key) => {
        const item = find(searchNavs, { key });
        if (item) {
            inactiveSearchNavs.push({ ...item });
            remove(searchNavs, { key });
        }
    });

    let searchNavList = SEARCH_LIST;
    const searchItem = find(searchNavList, { key: 'search' });
    searchItem.children = searchNavs;

    if (inactiveSearchNavs.length) {
        searchItem.children.push({
            key: 'moreSearch',
            label: 'searchMenus.moreSearch',
            eventType: 'showMoreSearch',
        });
    }

    //如果没有Saved query权限，需要隐藏菜单栏
    if (!savedQueryAuth) {
        const mySearchItem = find(searchNavList, { key: 'my_searches' });
        remove(mySearchItem.children, nav => {
            return nav.key === 'savedSearches';
        });
    }
    //如果没有expert权限，需要隐藏专家检索
    if (!hasExpert) {
        remove(searchItem.children, nav => {
            return nav.key === 'expertSearch';
        });
    }
    //特殊IP登陆的只有search菜单
    // FIXME: Search已不存在zPREFACE
    const isSpecialIpLogin = isSpecialIp || proxyDefaultValue.isSpecialIp;
    if (isSpecialIpLogin) {
        const navs = searchNavList.filter(item => {
            return item.key === 'search';
        });
        return {
            searchNavList: navs,
            inSearchNavList: inactiveSearchNavs,
        }
    }

    if (hasCas) {
        CAS_SEARCH.forEach(item => {
            if (!searchNavList.find(x => x.key === item.key)) {
                searchNavList.splice(1, 0, item);
            }
        });
    } else {
        const mySearches = SEARCH_LIST.find(x => x.key === 'my_searches');
        if (mySearches) {
            const index = mySearches?.children.findIndex(x => x.key === 'savedCASSearches');
            if (index > -1) {
                mySearches.children.splice(index, 1);
            }
        }
    }

    if (hasTelecom) {
        TELECOM_SEARCH.forEach(item => {
            if (!searchNavList.find(x => x.key === item.key)) {
                searchNavList.splice(1, 0, item);
            }
        });
    }
        
    if (hasAILab && !searchNavList.find(item => item.key === 'aiLab')) {
        searchNavList.unshift(...AI_LAB_LIST);
    }

    return {
        searchNavList: assignNavItemLink(searchNavList),
        inSearchNavList: assignNavItemLink(inactiveSearchNavs),
    };
}

export function getToolNavList({ isSpecialIp }) {
    // FIXME: Search已不存在zPREFACE
    const isSpecialIpLogin = isSpecialIp || proxyDefaultValue.isSpecialIp;
    if (isSpecialIpLogin) {
        return [];
    }
    return assignNavItemLink(TOOL_LIST);
}

const assignNavItemLink = (navList) => {
    forEach(navList, (item) => {
        if (item.pathKey) {
            item.label = item.label ? item.label : `commonNav.${item.key}`;
            item.fullPath = `${new Site({ sld: item.pathKey }).href}/${item.url}`;
        }
        if (item.children) {
            assignNavItemLink(item.children);
        }
    });
    return navList;
};

export default navService;
